import type { ThemeDefinition } from "vuetify";

export default {
  light: {
    dark: false,
    colors: {
      background: "#F4F7FA",
      surface: "#FFFFFF",
      primary: "#8b008b",
      base: "#F4F7FA",
      scroll: "#E0E0E0",
      card: "#FFFFFF",
      dropdown: "#EFEFEF",
    },
  } as ThemeDefinition,
  dark: {
    dark: true,
    colors: {
      background: "#1B1B1B",
      surface: "#131314",
      primary: "#be3ac3",
      base: "#1B1B1B",
      scroll: "#444746",
      card: "#1d1f1f",
      dropdown: "#1d1f1f",
    },
  } as ThemeDefinition,
};
